<template>
  <base-page>
    <el-card style="margin: 5px 0px 5px 0px">
      <el-collapse accordion style="border: none">
        <el-collapse-item name="1" style="border: none">
          <template slot="title">
            <div slot="header" class="clearfix">
              <titlu-pagina Titlu="Masini" @on_add_clicked="show_dialog()" :AdaugaVisible="true" />
            </div>
          </template>
          <div class="filtre">
            <el-form @submit.prevent.native="refresh_info()" label-position="top">
              <el-row style="margin: 10px" class="input-group">
                <el-col class="input-element">
                  <el-form-item label="Client">
                    <el-select class="full-width" v-model="Filters.IdClient" filterable>
                      <el-option v-for="item in Info.clienti" :key="'clienti' + item.Id" :label="item.Nume"
                        :value="item.Id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Numar">
                    <el-input v-model="Filters.Numar" />
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Marca">
                    <el-select v-model="Filters.Marca" @change="marcaChangeHandler()" class="full-width" filterable
                     clearable>
                      <el-option label="Toate" value="-1" />
                      <el-option v-for="item in Info.marci" :key="'marci' + item.Id" :label="item.Nume"
                        :value="item.Id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Model">
                    <el-select v-model="Filters.Model" @change="refresh_info" class="full-width" filterable
                      clearable :disabled="Filters.Marca == -1 || Filters.Marca == '' || !Filters.Marca">
                      <el-option label="Toate" value="-1" />
                      <el-option v-for="item in Info.modele" :key="'modele' + item.Id" :label="item.Nume"
                        :value="item.Id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Tip auto">
                    <el-select v-model="Filters.TipAuto" class="full-width">
                      <el-option label="Toate" value="-1"></el-option>
                      <el-option label="Normal" value="Normal"></el-option>
                      <el-option label="SUV" value="SUV"></el-option>
                      <el-option label="Autoutilitar" value="Autoutilitar"></el-option>
                      <el-option label="Supercar" value="Supercar"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="An">
                    <el-date-picker v-model="Filters.An" value-format="yyyy" :picker-options="datePickerOptions"
                      type="year" placeholder="Selecteaza anul">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Afiseaza sterse">
                    <el-select v-model="Filters.Sterse" class="full-width">
                      <el-option label="Da" value="1"></el-option>
                      <el-option label="Nu" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :md="24">
                  <el-button type="primary" native-type="submit" @click="refresh_info()">
                    Aplica
                  </el-button>
                  <el-button type="danger" native-type="submit" @click="reset()">
                    Reseteaza
                  </el-button>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-card>

    <el-table el-table :data="Results" class="tabelRandMic">
      <el-table-column prop="Id" label="#" width="80px" />
      <el-table-column prop="Numar" label="Numar">
        <template slot-scope="scope">
          {{ scope.row.Numar.toUpperCase() }}
        </template>
      </el-table-column>
      <el-table-column prop="MarcaNume" label="Marca"></el-table-column>
      <el-table-column prop="ModelNume" label="Model"></el-table-column>
      <el-table-column prop="An" label="An" width="100px" />
      <el-table-column prop="Km" label="Km" width="100px" />
      <el-table-column prop="NumeClient" label="Client" width="270px" />
      <el-table-column prop="TipAuto" label="Tip auto"></el-table-column>
      <el-table-column fixed="right" label="Actiuni" width="160px">
        <template slot-scope="scope">
          <el-tooltip content="Adauga programare noua">
            <el-button size="mini" class="butonReg" type="success" icon="el-icon-plus" circle
              @click="adauga_programarea(scope.row)" />
          </el-tooltip>
          <el-tooltip content="Modificare">
            <el-button size="mini" class="butonReg" type="primary" icon="el-icon-edit" circle
              @click="show_dialog(scope.row.Id)" />
          </el-tooltip>

          <el-tooltip content="Sterge">
            <el-button size="mini" class="butonReg" type="danger" icon="el-icon-delete" circle
              @click="delete_item(scope.row)" />
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination @size-change="refresh_info" @current-change="refresh_info" :page-size.sync="PaginationInfo.PerPage"
      :current-page.sync="PaginationInfo.Page" :total="PaginationInfo.RowCount" layout="pager" />
    <Masini-dialog ref="dlg" @save="refresh_info()" />
    <Rezervari-dialog v-show="false" ref="dlg_rez" @save="refresh_info()" />
  </base-page>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import Masini_dialog from "@/pages/Admin/masini/Masini_dialog.vue";
import Rezervari_dialog from "@/pages/Receptie/Rezervari_list.vue";
import TitluPagina from "@/widgets/TitluPagina";

export default {
  name: "masini",
  extends: BasePage,
  components: {
    "base-page": BasePage,
    "Masini-dialog": Masini_dialog,
    "Rezervari-dialog": Rezervari_dialog,
    "titlu-pagina": TitluPagina,
  },
  data() {
    return {
      Results: [],
      base_url: "",
      Info: {
        clienti: [],
        modele: [],
        marci: [],
      },
      Filters: {
        IdClient: "",
        Numar: "",
        Model: "-1",
        Marca: "-1",
        An: "",
        TipAuto: "-1",
        Sterse: '0',
      },
      OrderBy: {},
      PaginationInfo: {
        Page: 1,
        PerPage: 50,
        RowCount: 0,
        PageSizes: [10, 25, 50, 100, 200],
      },
      datePickerOptions: {
        disabledDate(date) {
          // console.log(date)
          return date > new Date();
        }
      },
    };
  },
  methods: {
    async get_info() {
      var response = await this.post("admin/masini/get_info");
      this.Info.clienti = response.clienti;
      this.Info.marci = response.marci;
      // if (this.Filters.IdClient.length > 0)
      //   this.Filters.IdClient = this.Info.clienti[0].Id;
      this.refresh_info();
    },

    async marcaChangeHandler() {
      if (!this.Filters.Marca || this.Filters.Marca == '-1') {
        this.Info.modele = [];
        this.Filters.Model = '-1';
      }
      if (this.Filters.Marca) {
        const response = await this.post("admin/masini/get_model_for_marca", { id_marca: this.Filters.Marca });
        if (response && response.modele) {
          this.Info.modele = response.modele;
        } else {
          this.Info.modele = [];
          this.Filters.Model = '';
        }
      }

      await this.refresh_info();
    },

    async adauga_programarea(masina_selectata_client) {


      // console.log(masina_selectata_client)

      let client = { "Id": masina_selectata_client.IdClient };

      // let masina_selectata_client = this.masini_disponibile_client.filter((value) => value.Id == this.IdMasinaSelectataProgramare)[0];

      // masina_selectata_client.client = 8;
      // return;

      this.$refs.dlg_rez.programeaza_client(client, masina_selectata_client);

      this.showPopupProgramareNoua = false;

    },

    async refresh_info() {
      var response = await this.post("admin/masini/index", {
        Filters: this.Filters,
        OrderBy: this.OrderBy,
        PaginationInfo: this.PaginationInfo,
      });
      this.Results = response.Results;
      this.PaginationInfo = response.PaginationInfo;
      this.PaginationInfo.Page = 1;
      // console.log(this.PaginationInfo);
      //
      this.select_menu_item("clienti_cat");
    },
    reset() {
      this.Filters = {
        IdClient: "",
        Numar: "",
        Model: "-1",
        Marca: "-1",
        An: "",
        TipAuto: "-1",
        Sterse: '0',
      };
      this.refresh_info();
    },

    async delete_item(item) {
      try {
        const response = await this.post("admin/masini/get_numar_devize_programari_masina", { idMasina: item.Id });
        if (response) {
          if (response.NumarDevize != 0 || response.NumarRezervari != 0) {
            this.deleteMsg = "Aceasta masina apare pe " + response.NumarDevize + " deviz/e si " + response.NumarRezervari + " rezervari. Doriti sa continuati stergerea?";
          } else {
            this.deleteMsg = "Sunteti sigur?";
          }
          this.$confirm(this.deleteMsg, 'Atentie', { confirmButtonText: 'Da', cancelButtonText: 'Nu', type: 'warning' })
            .then(async () => {
              await this.post("admin/masini/delete_item", { id: item.Id });
              this.refresh_info();
            })
            .catch(async () => {
              this.$message({ type: 'info', message: 'Stergerea a fost anulata!' });
            });
        }
      } catch (error) {
        console.error(error)
      }
    },

    show_dialog(id) {
      this.$refs.dlg.show_me(id);
    },
  },
  mounted() {
    if (!this.$has_right('Management') && !this.$has_right('Supervizor')) {
      this.$router.push("/no-rights");
      return;
    }
    this.base_url = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less" scoped>
.top50 {
  margin-top: 20px;
}

.filtre {
  .el-input-number {
    width: 100% !important;
  }
}

.input-element {
  margin-right: 2%;
  width: 31%;
}

@media only screen and (max-width: 600px) {
  .input-element {
    width: 80%;
  }

  .el-tooltip__popper {
    width: 90%;
  }
}
</style>
